import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 20.304 17.326",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" stroke=\"#866833\" stroke-linecap=\"square\" viewBox=\"0 0 20.304 17.326\" id=\"menu\"><g fill=\"none\" stroke-linejoin=\"round\" stroke-width=\"2\"><path d=\"M1 1h18.304M1 16.326h9.5M1 8.664h14.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol